import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";

// Warn if required env vars are missing (non-blocking)
const requiredEnvVars = ["VITE_FIREBASE_API_KEY", "VITE_FIREBASE_AUTH_DOMAIN", "VITE_FIREBASE_PROJECT_ID"] as const;
for (const key of requiredEnvVars) {
  if (!import.meta.env[key]) {
    console.warn(`[env] Missing ${key} — auth may not work correctly`);
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
